import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css, keyframes } from 'styled-components';
import splashImg from '../img/splash.gif';
import { fadeIn, fadeOut } from '../components/common/AnimationCommon';
import progress_loop from '../img/progress_loop.png';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { isProducType_WITH_URL_OPENER_B2B } from '../utils/producTypeUtils';
import { isDevicePC } from '../utils/util';
import LoadingSplashMobile from './common/mobile/LoadingSplashMobile';
import { useAppLoadingSliceSelector } from '../store/modules/appLoading';

const ANIM_TIME = 250;

export const Image = styled.img`
  margin: 0 auto;
`;

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #fff;
  ${({ visible }) =>
    !visible &&
    css`
      animation-duration: ${ANIM_TIME}ms;
      animation-timing-function: ease-out;
      animation-name: ${fadeOut};
      animation-fill-mode: forwards;
    `}
`;

const SplashArea = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 440px;
  width: 500px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TimeDelayMsg = styled.p`
  margin: 0 0;

  ${({ visible }) =>
    visible
      ? css`
          animation-duration: ${ANIM_TIME}ms;
          animation-timing-function: ease-out;
          animation-name: ${fadeIn};
          animation-fill-mode: forwards;
        `
      : css`
          display: none;
        `}
`;

const play = keyframes`
100% {background-position : -1900px;}
`;

export const AnimationBar = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-image: url(${progress_loop});
  animation: ${play} 0.9s steps(19) infinite;
  transform: translate(0, -10px);
`;

const MovingForSeriveMsg = styled.p`
  margin: 0 0;
`;

const MessageArea = styled.div`
  position: absolute;
  bottom: 77px;
  width: 100%;
  height: 54px;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

function LoadingSplash() {
  const appData = useAppDataSliceSelector();
  const { t } = useTranslation();
  const visible = useAppLoadingSliceSelector().loading;
  const [isSHowTimeDelayMsg, setIsSHowTimeDelayMsg] = useState(false);
  const [isShowAnimationBar, setIsShowAnimationBar] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(false);
  const isPCView = isDevicePC(appData.deviceType);

  useEffect(() => {
    setTimeout(() => setIsSHowTimeDelayMsg(true), 3000);
    setTimeout(() => setIsShowAnimationBar(true), 500);
  }, []);

  useEffect(() => {
    if (localVisible && !visible) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), ANIM_TIME);
    }
    setLocalVisible(visible);
  }, [localVisible, visible]);

  if (!animate && !localVisible) return null;

  return (
    <Wrapper visible={visible}>
      {isPCView === true ? (
        <>
          <SplashArea>
            <Image src={splashImg} alt="splash" />
            {isShowAnimationBar && <AnimationBar width="100px" height="40px" />}
          </SplashArea>
          <MessageArea>
            {isProducType_WITH_URL_OPENER_B2B(appData.productType) && (
              <MovingForSeriveMsg>{t('LoadingSplash.MovingForSeriveMsg')}</MovingForSeriveMsg>
            )}
            <TimeDelayMsg visible={isSHowTimeDelayMsg}>
              {t('LoadingSplash.TimeDelayMessage')}
            </TimeDelayMsg>
          </MessageArea>
        </>
      ) : (
        <LoadingSplashMobile
          isShowAnimationBar={isShowAnimationBar}
          isSHowTimeDelayMsg={isSHowTimeDelayMsg}
        />
      )}
    </Wrapper>
  );
}

export default LoadingSplash;
